import { mapGetters, mapActions } from "vuex";

export default {
    computed: {
        ...mapGetters('editArticle', ['getSectionById']),
    },
    methods: {
        ...mapActions('editArticle', ['updateSection']),
        onRemoveClick(){
            this.$emit('alert-remove-content', this.content);
        },
        onArrowUp(){
            this.moveContent(-1);
        },
        onArrowDown(){
            this.moveContent(1);
        },
        moveContent(amount){
            let section = this.getSectionById(this.content.section_id);
            let contentList = section.contents;
            
            const moveContent = contentList.find(c => c.id === this.content.id);
            const indexOfContent = contentList.indexOf(moveContent);
            let swapTarget = contentList[indexOfContent + amount];

            if(!swapTarget || indexOfContent < 0){
                return;
            }

            contentList[indexOfContent + amount] = contentList[indexOfContent];
            contentList[indexOfContent] = swapTarget;
            contentList.reverse();
            contentList.reverse();
        }
    }
}